import { render, staticRenderFns } from "./WebStore.vue?vue&type=template&id=356c52ba&scoped=true&"
import script from "./WebStore.vue?vue&type=script&lang=js&"
export * from "./WebStore.vue?vue&type=script&lang=js&"
import style0 from "./WebStore.vue?vue&type=style&index=0&id=356c52ba&prod&lang=scss&"
import style1 from "./WebStore.vue?vue&type=style&index=1&id=356c52ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356c52ba",
  null
  
)

export default component.exports